import classNames from 'classnames';
import PropTypes from 'prop-types';
import { parse } from 'query-string';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useParams, useLocation } from 'react-router';

import useScrollToTop from '../../hooks/useScrollToTop';

import { useUrlGenerator } from '../../contexts/RoutesContext';
import ResetPasswordForm from '../forms/ResetPassword';
import MainLayout from '../layouts/Main';

import styles from '../../../styles/pages/form.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ResetPasswordPage = ({ className }) => {
    const route = useUrlGenerator();
    const history = useHistory();
    const location = useLocation();
    const { search } = location;
    const { token } = useParams();
    const { email } = parse(search || null);

    const onComplete = useCallback(() => {
        history.push(`${route('login')}?changed=1`);
    }, [history, route]);

    useScrollToTop(location);

    return (
        <MainLayout>
            <div
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <div className={styles.inner}>
                    <fieldset className={styles.formFrame}>
                        <h2 className={styles.formHeading}>
                            <FormattedMessage
                                defaultMessage="Reset your password"
                                description="Form heading"
                            />
                        </h2>
                        <ResetPasswordForm email={email} token={token} onComplete={onComplete} />
                    </fieldset>
                </div>
            </div>
        </MainLayout>
    );
};
ResetPasswordPage.propTypes = propTypes;
ResetPasswordPage.defaultProps = defaultProps;

export default ResetPasswordPage;
